'use strict';


import {Component,Inject, Input} from 'ng-metadata/core';


import {PrimolyticsService, beacon} from '../../../analytics/primolytics.service';
import {FacetService} from '../facet.service';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {getAttributesMap} from "../../../appConfig/appConfigForward";
import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";
import {isBrowserSafari} from "../../../infra/browserSniffer";
const get = require('lodash/get');

@Component({
selector: 'prm-facet-range',
templateUrl: 'components/search/facet/facetRange/facet-range.html',
})


export class PrmFacetRange{
    @Input() facetGroup: any;
    private isCollapsed:boolean;
    private _facetGroupHeader: string;
    
    constructor(private facetService: FacetService,
                private primolyticsService: PrimolyticsService,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService,
                private configurationUtil: ConfigurationUtil,
                private analyticsUtils: AnalyticsUtils) {
    }



    /**
     * @ngdoc method
     * @name addFacet
     * @methodOf starter.controller:FacetController
     * @description
     * Add facet to query and perform a new search
     * Performs a search together with facets
     * @param {string} name - The facet name selected
     * @param {string} value - The facet value to search
     */
    @beacon({'p': 'refine'})
    public addFacet(name, label, value, facetType, displayedType, minValue, maxValue,operation) {
        let facetString= name+','+facetType+','+value;
        this.facetService.facetSearch({facet: facetString});
        this.sendRangeFacetAnalytics(name, value, facetType, label);
    }
    
    get rangeFacetValue() {
        return this.facetService.getRangeFacetValue(this.rangeFacetMinValue, this.rangeFacetMaxValue);
    }

    get rangeFacetMinValue() {
        if(undefined == this.facetGroup.additionalData.selectedMin){
            return this.facetGroup.additionalData.min
        }
        return this.facetGroup.additionalData.selectedMin;
    }

    get rangeFacetMaxValue() {
        if(undefined == this.facetGroup.additionalData.selectedMax){
            return this.facetGroup.additionalData.max
        }
        return this.facetGroup.additionalData.selectedMax;
    }

    get rangeFacetLabel() {
        return this.facetService.getRangeFacetLabelFromValue(this.rangeFacetValue);
    }
    
    public toggleMultiRangeFacet(value) {
        this.facetService.toggleMultiRangeFacet(value);
    }
    
    public changeMultiFacetVal(value) {
        if (this.facetService.activeRangeMultiFacet) {
            this.facetService.replaceMultiRangeFacet(value);
        }
    }

    public ariaLabelForFacet(facetType) {
        if (facetType === 'exclude') {
            return this.$translate.instant('nui.facets.exclude.tooltip');
        }
        else {
            return this.$translate.instant('nui.facets.include.tooltip');
        }
    }

    public toggleFacet(event) {
        let elem = event.target;
        this.facetGroup.facetGroupCollapsed = !this.facetGroup.facetGroupCollapsed;
        elem.setAttribute('aria-expanded', this.facetGroup.facetGroupCollapsed);
    }

    get facetGroupHeader () {
        return this._facetGroupHeader;
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }



    get isSafariBrowse() {
        return isBrowserSafari();
    }

    private sendRangeFacetAnalytics(name, value, facetType, label) {
        let payload = this.getRangeFacetAnalyticsPayload(name, value, facetType, label);
        this.facetService.sendAnalytics(this.analyticsUtils.eventsNames.FACETS_USAGE, payload);
    }

    private getRangeFacetAnalyticsPayload(name, value, facetType, label) {
        return {
            "Facet Action Type": 'Add',
            "Facets Count": '1',
            "Facet Method": this.facetService.capitalizeFirstLetter(facetType),
            "Facet Type": [name],
            "Facet Type Name": [this.facetService.getTranslatedFacetGroupName('creationdate')],
            "Facet Value": [value],
            "Facet Value Name": [label]
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/facet/facetRange/facetRange.directive.ts